//import Moment from "moment";

const dataFormatada = (state) => {
    if (!state.empresa || !state.empresa.data) return null;
    return Moment(String(state.empresa.data)).format("DD/MM/YYYY");
}

const getCount = (state) => {
	return state.empresas.length;
}

export default {
    dataFormatada,
	getCount
}